/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../utility/Constant";

const HomeBanner = () => {
  const { homeApi } = apiPath;
  const { clientHome } = clientSideUrl;
  const [homeBannerData, homeBannerLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState();

  useEffect(() => {
    setFilteredData(
      homeBannerData?.filter((item) => item.section_type === "banner")[0]
    );
  }, [homeBannerData]);

  if (homeBannerLoading) {
    return <Loading />;
  }

  const {
    banner_left_title,
    banner_sub_title,
    banner_title,
    who_we_are_description,
    banner_images,
    _id,
  } = filteredData ?? {};

  const imagesData = [];
  banner_images?.map((item, index) => {
    imagesData.push({
      label: `Banner Image ${index}`,
      type: "input",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "SideBar Title",
      type: "Text",
      name: "banner_left_title",
      defaultValue: banner_left_title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner Subtitle",
      type: "Text",
      name: "banner_sub_title",
      defaultValue: banner_sub_title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "banner_title",
      defaultValue: banner_title,
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "inputObject",
      label: "Banner Image",
      name: "banner_images",
      multipleData: imagesData,
      multiple: false,
      required: false,
    },
  ];

  const useData = data.concat(nestedData);

  const update = async (data) => {
    if (data.banner_images) {
      let link = data.banner_images;
      data.banner_images = [
        {
          url: link,
        },
      ];
    }
    updateData(homeApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  console.log(filteredData);

  return (
    <div>
      <div className="mb-0 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientHome}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">

        {banner_title && (
          <GlobalForm data={useData} nestedData={nestedData} update={update} />
        )}
      </div>
    </div>
  );
};

export default HomeBanner;
